import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'super_admin' | 'student';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const userStr = localStorage.getItem('user');
  
  if (!userStr) {
    // 로그인하지 않은 경우 로그인 페이지로 리다이렉트
    return <Navigate to="/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);
    
    // 역할 검증
    if (requiredRole && user.role !== requiredRole) {
      // 권한이 없는 경우 로그인 페이지로 리다이렉트
      return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
  } catch (error) {
    // 잘못된 사용자 데이터인 경우
    localStorage.removeItem('user');
    return <Navigate to="/login" replace />;
  }
}
